'use client';
export const PIXEL_ID = '427953549859506';

export const initPixel = () => {
    return import('react-facebook-pixel')
        .then(x => x.default)
        .then(ReactPixel => {
            console.log('init pixel', ReactPixel);
            ReactPixel.default.init(PIXEL_ID, {
                autoConfig: true,
                debug: true,
            });
            ReactPixel.default.pageView();
            return ReactPixel;
        });
};

export const trackPixel = (event, data) => {
    import('react-facebook-pixel')
        .then(x => x.default)
        .then(ReactPixel => {
            console.log('track pixel', event, data);
            ReactPixel.default.customTrack(event, data);
        });
};
